import { action } from 'typesafe-actions';

import { AdminAIChatbotActionTypes, CustomDocumentQueryAnalytics } from './types';

export const fetchCustomQueriesAnalyticsStarted = (clientId?: number, userId?: number) => action(AdminAIChatbotActionTypes.FETCH_CUSTOM_QUERY_ANALYTICS_STARTED, { clientId, userId });
export const fetchCustomQueriesAnalyticsSuccessful = (customDocumentQueryAnalytics: CustomDocumentQueryAnalytics) => action(AdminAIChatbotActionTypes.FETCH_CUSTOM_QUERY_ANALYTICS_SUCCESSFUL, customDocumentQueryAnalytics);
export const fetchCustomQueriesAnalyticsFailed = (e: string) => action(AdminAIChatbotActionTypes.FETCH_CUSTOM_QUERY_ANALYTICS_FAILED, e);
